// assets
import {
  IconDashboard,
  IconBuilding,
  IconSitemap,
  IconArticle,
  IconAdjustments,
  IconPhoto,
  IconBed,
  IconChartLine,
  IconCreditCard,
  IconHeartbeat,
  IconWallet,
  IconKey,
  IconUser,
  IconUsers,
  IconUserScan,
  IconShare3
} from '@tabler/icons-react';

// constant
const icons = {
  IconDashboard,
  IconBuilding,
  IconSitemap,
  IconArticle,
  IconAdjustments,
  IconPhoto,
  IconBed,
  IconChartLine,
  IconCreditCard,
  IconHeartbeat,
  IconWallet,
  IconKey,
  IconUser,
  IconUsers,
  IconUserScan,
  IconShare3
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'hotel-workbench',
      title: '今日必做',
      type: 'item',
      url: '/panel/hotel-workbench',
      icon: icons.IconBuilding,
      breadcrumbs: false,
      roles: ['hotel']
    },
    {
      id: 'rooms',
      title: '房间管理',
      type: 'item',
      url: '/panel/rooms',
      icon: icons.IconBed,
      breadcrumbs: false,
      roles: ['hotel']
    },
    {
      id: 'hotel-recharge',
      title: '会员充值',
      type: 'item',
      url: '/panel/hotel-recharge',
      icon: icons.IconCreditCard,
      breadcrumbs: false,
      roles: ['hotel']
    },
    {
      id: 'hotel-opportunities',
      title: '周边信息',
      type: 'item',
      url: '/panel/hotel-workbench?tool=competitor',
      icon: icons.IconChartLine,
      breadcrumbs: false,
      roles: ['hotel']
    },
    {
      id: 'hotel-promo',
      title: '发宣传',
      type: 'item',
      url: '/panel/hotel-workbench?tool=promo',
      icon: icons.IconPhoto,
      breadcrumbs: false,
      roles: ['hotel']
    },
    {
      id: 'hotel-marketing',
      title: '全员营销',
      type: 'item',
      url: '/panel/hotel-marketing',
      icon: icons.IconShare3,
      breadcrumbs: false,
      roles: ['hotel']
    },
    {
      id: 'dashboard',
      title: '总览',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false,
      roles: ['admin', 'agent']
    },
    {
      id: 'hotels',
      title: '酒店',
      type: 'item',
      url: '/panel/hotels',
      icon: icons.IconBuilding,
      breadcrumbs: false,
      roles: ['admin', 'agent']
    },
    {
      id: 'agents',
      title: '代理',
      type: 'item',
      url: '/panel/agents',
      icon: icons.IconUsers,
      breadcrumbs: false,
      roles: ['admin', 'agent']
    },
    {
      id: 'payments',
      title: '支付',
      type: 'item',
      url: '/panel/payments',
      icon: icons.IconCreditCard,
      breadcrumbs: false,
      roles: ['admin', 'agent']
    },
    {
      id: 'revenue',
      title: '收益',
      type: 'item',
      url: '/panel/revenue',
      icon: icons.IconWallet,
      breadcrumbs: false,
      roles: ['admin', 'agent']
    },
    {
      id: 'ai-tasks',
      title: 'AI任务',
      type: 'item',
      url: '/panel/ai-tasks',
      icon: icons.IconPhoto,
      breadcrumbs: false,
      roles: ['admin']
    },
    {
      id: 'diagnostic',
      title: '诊断',
      type: 'item',
      url: '/panel/diagnostic',
      icon: icons.IconHeartbeat,
      breadcrumbs: false,
      roles: ['admin']
    },
    {
      id: 'user',
      title: '用户',
      type: 'item',
      url: '/panel/user',
      icon: icons.IconUser,
      breadcrumbs: false,
      roles: ['admin']
    },
    {
      id: 'channel',
      title: '阿里接口',
      type: 'item',
      url: '/panel/channel',
      icon: icons.IconSitemap,
      breadcrumbs: false,
      roles: ['admin']
    },
    {
      id: 'token',
      title: 'API 访问令牌',
      type: 'item',
      url: '/panel/token',
      icon: icons.IconKey,
      breadcrumbs: false,
      roles: ['admin']
    },
    {
      id: 'log',
      title: '日志',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      breadcrumbs: false,
      roles: ['admin', 'agent']
    },
    {
      id: 'profile',
      title: '我的',
      type: 'item',
      url: '/panel/profile',
      icon: icons.IconUserScan,
      breadcrumbs: false,
      roles: ['admin', 'agent', 'hotel']
    },
    {
      id: 'setting',
      title: '设置',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      breadcrumbs: false,
      roles: ['admin']
    }
  ]
};

export default panel;
